import * as React from "react";
import { useContext, useState } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { InputChangeEvent } from "@progress/kendo-react-inputs/dist/npm/input/interfaces/InputChangeEvent";
import { EditProjectContext } from "../../EditProjectContext";
import { isProjectReadOnly } from "../../IsProjectReadOnly";
import { InputButtonGroup } from "../../../../Layout/Inputs/InputButtonGroup";
import { useAddSpdrOrPdsrToProject } from "../../Hooks/useAddSpdrOrPdsrToProject";
import SaveProject from "../../SaveProject";

type Props = {
  disabled: boolean;
};

export const AddSpdrsAndPdsrs = ({ disabled }: Props) => {
  const { project, reloadData } = useContext(EditProjectContext);
  const [inputValue, setInputValue] = useState("");
  const addSpdrOrPdsrToProject = useAddSpdrOrPdsrToProject;

  const handleOnClick = async () => {
    await SaveProject({ project });
    await addSpdrOrPdsrToProject(project.ProjectId, inputValue);
    reloadData();
  };

  return isProjectReadOnly(project) ? (
    <div />
  ) : (
    <InputButtonGroup style={{ padding: "0.3rem", paddingBottom: "16px" }}>
      <Input
        onChange={(e: InputChangeEvent) => {
          setInputValue(e.value);
        }}
        value={inputValue}
        placeholder="ADD NEW SPDR/PDSR’s"
        disabled={disabled}
      />
      <Button onClick={() => handleOnClick()} disabled={disabled}>
        <FontAwesomeIcon icon={faAdd} />
      </Button>
    </InputButtonGroup>
  );
};
